module.exports = __webpack_public_path__ + "static/media/carp_mobile1.d668ba28.PNG";